export const USER_IDENTITY_SET_EVENT = 'userIdentitySet'
